<template>
  <div class="content-base">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="header-content">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.params.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-title">
      <span v-for="(item,index) in TypeList" :key="index" @click="HandleDeal(index,item.code)"
            :class="{current: Current == index}"
      >{{item.name}}</span>
    </div>
    <div class="content-base">
      <div class="base-content">
        <content-classify ref="classify" @code="handlecode"  />
        <div class="des" v-html="concept.description" v-if="concept"></div>
        <content-base-item  :content-img="concept.photoUrl" v-if="concept"></content-base-item>
        <div v-else>暂无内容</div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentClassify from "./item/classify";
import ContentBaseItem from "../Common/ContentBaseItem";
export default {
  name: "ContentBase",
  components: {ContentBaseItem, ContentClassify},
  data(){
    return{
      TypeList:null,
      Current:0,
      concept:null,
      postData:{
        'type':null,
        'smallType':1,
      }
    }
  },
  created() {
    if(this.$route.params.name == '媒体服务'){
      this.postData.type=3
    }
    if(this.$route.params.name == '影音系统集成'){
      this.postData.type=1
    }
    if(this.$route.params.name == '声像专业场所建设'){
      this.postData.type=2
    }
    this.GetTypeList(this.$route.params.name)
    this.GetDetailData(this.postData)

  },
  watch:{
    '$route.params.name'(name){
      if(name == '媒体服务'){
        this.GetTypeUrl('/api/serveItem/getMediaServeTypeList')
        this.postData.type=3
        this.GetDetailData(this.postData)
      }
      if(name == '影音系统集成'){
        this.GetTypeUrl('/api/serveItem/getAudioTypeList')
        this.postData.type=1
        this.GetDetailData(this.postData)
      }
      if(name == '声像专业场所建设'){
        this.GetTypeUrl('/api/serveItem/getAcousticTypeList')
        this.postData.type=2
        this.GetDetailData(this.postData)
      }
    },

  },
  methods:{
    GetTypeList(name){
      if(name == '媒体服务'){
        this.GetTypeUrl('/api/serveItem/getMediaServeTypeList')
        this.postData.type=3
        this.GetDetailData(this.postData)
      }
      if(name == '影音系统集成'){
        this.GetTypeUrl('/api/serveItem/getAudioTypeList')
        this.postData.type=1
        this.GetDetailData(this.postData)
      }
      if(name == '声像专业场所建设'){
        this.GetTypeUrl('/api/serveItem/getAcousticTypeList')
        this.postData.type=2
        this.GetDetailData(this.postData)
      }
    },
    GetTypeUrl(url){
      this.$axios.get(url).then(res=>{
        this.TypeList=res.data.data
      })
    },
    HandleDeal(index,code){
      this.Current=index;
      this.postData.smallType=code
      this.GetDetailData(this.postData)
    },
    handlecode(name){
      this.Current=0
      this.$router.push('/content/name='+name)

    },
    GetDetailData(data){
      this.$axios.post('/api/serveItem/getList',data).then(res=>{
        this.concept=res.data.data.records[0]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content-base{
  .header{
    height: 44px;
    background: #F6F7F8;
    .header-content{
      line-height: 44px;
      margin: 0 auto;
      width: 74.5%;
      /*padding:10px;*/
    }
  }
  min-height: 66vh;
  .content-title{
    width: 74.5vw;
    margin: 0 auto;
    overflow: hidden;
    min-width: 1000px;
    height: 100px;
    line-height: 100px;
    span{
      padding: 4px 15px;
      margin: 10px 25px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 27px;
      cursor: pointer;
    }
    .current{
      background: #188ACB;
      border-radius: 20px;
      color: white;
    }
  }
  .content-base{
    padding-top: 40px;
    height: 575px;
    display: flex;
    .base-content{
      width: 74.5vw;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .des{
        width: 500px;
        overflow: hidden;
        word-wrap: break-word;
        padding: 10px;
      }
    }
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    background: url('../../../assets/service/bg@3x.png') center center / cover no-repeat ;
  }
}
</style>